<!--
<app-notifications></app-notifications>
-->

<section class="content">
  <h1>Umsatz <span class="text-small"> (ohne MwSt.)</span></h1>
  <h2 class="mb-0">{{ 'MONTHS.' + revenue?.month | translate }} {{ today |date: 'yyyy' }} </h2>
  @if (revenue?.updated_at) {
    <span class="text-small">Stand: {{ revenue?.updated_at | date: 'dd.MM.yyyy HH:mm' }}</span>
  }
  <div class="d-flex my-m w-100">
    <div class="totals-element">
      <img src="assets/icons/euro.svg" alt="Euro sign icon" width="80">
      <span class="small p-0 mb-0 mt-s">Umsatz total</span>
      <span
        class="text-xlarge">{{ (revenue?.total_revenue ? revenue.total_revenue : 0) | currency:'EUR':'symbol':'1.2-2' }}</span>
    </div>
    <div class="totals-element">
      <img src="assets/icons/packungen.svg" alt="Packungen icon" width="80">
      <span class="small p-0 mb-0">Anzahl RX Packungen
            <span class="material-symbols-outlined" matTooltip="inkl. Hochpreis">info</span></span>
      <span class="text-xlarge">{{ (revenue?.rx_packet_count ? revenue.rx_packet_count : 0)  | number }}</span>
    </div>
  </div>
</section>

<section class="content">
  <h2>Monatlicher Umsatzverlauf</h2>
  <div echarts [options]="chartOptions" (chartInit)="onChartInit($event)"  class="chart" style="height: 400px;"></div>
  <div class="download-container">
    <p class="text-center">Download:</p>
    <div class="buttons">
      <button mat-flat-button color="primary" (click)="savePdf('Gesamt')"><span>.pdf</span></button>
    </div>
  </div>
</section>

<section class="content">
  <h2>Anzahl RX Packungen</h2>
  <div echarts [options]="chartRxPacketsOptions" (chartInit)="onChartInitRx($event)" class="chart"></div>
  <div class="download-container">
    <p class="text-center">Download:</p>
    <div class="buttons">
      <button mat-flat-button color="primary" (click)="savePdf('RXPackets')"><span>.pdf</span></button>
    </div>
  </div>
</section>

@if (isLive()) {
  <!--<section class="content">-->
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title red">
          Informationen zum Energiekostenzuschlag (EKZ)
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul>
        <li>
          <a class="linki" target="_blank"
             href="https://www.adac.de/verkehr/tanken-kraftstoff-antrieb/deutschland/kraftstoffpreisentwicklung/#spritpreise-die-letzten-24-monate">Dieselpreise
            laut ADAC</a>
        </li>
        <li>
          <a class="linki" target="_blank" disabled
             href="https://cspappsacc.blob.core.windows.net/cms/files/2026/Übersicht EKZ gemäß Dieselpreis.pdf">Übersicht
            EKZ gemaß Dieselpreis</a>
        </li>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>
  <!--  </section>-->
}
